import { SystemService } from '../../service/system.service';
import { HttpClient } from '@angular/common/http';
var homedashService = (function () {
    function homedashService(http) {
        this.http = http;
        this.url = '';
        this.systemService = new SystemService();
        this.url = this.systemService.getAppUrl();
    }
    homedashService.prototype.getHomeData = function () {
        var url = this.url + "home/dashboard";
        return this.http.get(url)
            .toPromise()
            .then(function (response) {
            if (response) {
                //   this.dashboardObj = response.json();
                // return JSON.stringify(response);
                return response;
            }
            // return this.dashboardObj;
        })
            .catch(function (reason) {
            console.error(reason);
            // return reason;
        });
    };
    return homedashService;
}());
export { homedashService };



// WEBPACK FOOTER //
// C:/Neutrinos/mul-bhive-studio/multichoice/app/src/app/services/homeDash/homedash.service.ts.pre-build-optimizer.js